import axios from "axios";
import { BASE_URL } from "../../Constants/apiConstant";
import { store } from "../../redux/Store.ts";
import actions from "../../redux/Actions.ts";
import { handleLogout } from "../../Utils/logout.ts";

console.log("BASE_URL", BASE_URL);
export const api = axios.create({
  withCredentials: false,
  baseURL: BASE_URL,
});

const errorHandler = (error) => {
  const statusCode = error.response?.status;
  const code = error.response?.data?.code;

  // Claude: SESSION_TERMINATED — another device force-logged in, kicking this session 18-04-2026
  if (statusCode === 401 && code === "SESSION_TERMINATED") {
    window.dispatchEvent(new Event("session-terminated"));
    return new Promise(() => {});
  }

  // Claude: 401/403 — session expired or forbidden; redirect to role-appropriate login page 22-04-2026
  // Claude: exempt login endpoints — a 401 there means wrong credentials, not an expired session 27-04-2026
  // Claude: use pathname (not Redux role) — Redux role is cleared on first handleLogout call so concurrent 401s would see null role and fall back to /login 28-04-2026
  const isLoginRequest = error.config?.url?.includes('/auth/login');
  if ((statusCode === 401 || statusCode === 403) && !isLoginRequest) {
    const isAdmin = window.location.pathname.startsWith('/admin');
    const redirectTo = isAdmin ? "/admin/login" : "/login";
    // Claude: pass 'expired' only for 401 — 403 is a permissions issue, not an expired session 28-04-2026
    handleLogout(redirectTo, statusCode === 401 ? "expired" : undefined);
    return new Promise(() => {});
  }

  if (statusCode) {
    console.error(error);
  }

  return Promise.reject(error);
};

api.interceptors.response.use(undefined, (error) => {
  return errorHandler(error);
});
